import { tw } from "@careinfo/tailwind";
import { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import DateRangePicker from "../Reusable/DateRangeField";
import moment from "moment";

export default function Filter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const { control, setValue, getValues } = useForm({
    defaultValues: {
      fromDate: searchParams.get("fromDate") || "",
      toDate: searchParams.get("toDate") || "",
      created: `${startOfMonth},${endOfMonth}`,
    },
  });
  const formValues = useWatch({ control });
  useEffect(() => {
    const clonedParams = new URLSearchParams(searchParams.toString());
    for (const [k, v] of Object.entries(formValues)) {
      if (v) {
        clonedParams.set(k, v);
      } else {
        clonedParams.delete(k);
      }
    }
    setSearchParams(clonedParams);
  }, [formValues, setSearchParams, searchParams]);

  return (
    <div
      className={tw`p-2 rounded-md space-y-4 bg-white`}
      style={{
        boxShadow: "0px 1px 6px 0px #00000040",
      }}
    >
      <div className={tw`grid grid-cols-2 gap-6`}>
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"created"}
          getValues={getValues}
        />
      </div>
    </div>
  );
}

